import { Controller } from "@hotwired/stimulus"

// Controller for inline editing of core values
export default class extends Controller {
  static targets = ["display", "actions", "form"]

  edit() {
    this.displayTarget.classList.add("hidden")
    this.actionsTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")
    // Focus the first input
    const input = this.formTarget.querySelector("input")
    if (input) input.focus()
  }

  cancel() {
    this.displayTarget.classList.remove("hidden")
    this.actionsTarget.classList.remove("hidden")
    this.formTarget.classList.add("hidden")
    // Reset form
    const form = this.formTarget.querySelector("form")
    if (form) form.reset()
  }
}
